export default "__VITE_ASSET__DU1mI_uN__"